import { Component, OnInit, ViewEncapsulation, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { GeneralStore } from "../../../../../../services/store/general";
import { MC_APPLICATIONS_ERROR, MCFormatTextPipe } from "@maslul/common-services";


@Component({
    selector: 'mi-error',
    imports: [
        MCFormatTextPipe
    ],
    templateUrl: './error.html',
    styleUrl: './error.scss',
    encapsulation: ViewEncapsulation.None
})
export class ErrorComponent implements OnInit {
    private translateService = inject(TranslateService);
    private generalStore = inject(GeneralStore);

    subscription: Subscription = new Subscription();
    errorText: any;
    errorPageCode!: MC_APPLICATIONS_ERROR;


    ngOnInit() {
        this.initText();
        this.init();
    }


    initText() {

        this.subscription.add(this.translateService.stream('error').subscribe(translation => {
            this.errorText = translation;
        }));

    }

    init() {
        this.errorPageCode = this.generalStore.getSnapshot().errorPageCode;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}


